<template>
    <div>
        <section v-if="paso1" class="padding-vertical-content white-content right-background">
            <div class="thumb-container absolute grayscale light-thumb" :style='"background-image: url(" + manager.bg2_url + ")"'></div>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row justify-content-start">
                            <div class="col-12 col-lg-6 col-xl-5">
                                <h2 class="m-0 mt-5 h1 text-uppercase">{{ $t('renovar_abono.renueva_abono', {abono: teatro.texto_abono}) }}</h2>
                                <div class="subtitle h3 light mb-3 mb-lg-5"> {{ $t('renovar_abono.temporada', { temporada: lista_abonados.nombre }) }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 col-xl-5">
                        <BuscarAbonadoLfp
                            @terminado="abonadoEncontrado"
                            @documentacion="setDocumentacion"
                        />
                        <div v-if="yaRenovado" class="alert alert-warning mt-3">
                            <i class="fas fa-check-circle mr-1"></i>
                            {{ $t('renovar_abono.ya_renovado', {abono: teatro.texto_abono}) }}
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content white-content mb-3 mb-lg-4" v-if="envio" key="envio" id="envio">
                <div class="container">
                    <div class="row">
                        <EnviosComponent
                            :datos_compradores="[abonado, []]"
                            :desactivar="paso2 || procesar_pago ? true : false"
                            @envioSolicitado="envioSolicitado"
                            @continuarSinEnvio="continuarSinEnvio"
                        />
                    </div>
                </div>
            </section>
        </transition>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content white-content mb-3 mb-lg-4" v-if="paso2" key="paso2" id="paso2">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="padding-content white-content mb-4">
                                <PersonaInfoForm
                                    :data="abonado"
                                />
                            </div>
                        </div>
                        <div class="col-12" v-if="solicitar_documentacion">
                            <label class="pb-3">{{ texto_documentacion || 'Adjuntá la documentación requerida' }}</label>
                            <Dropzone
                                v-if="url_documentacion"
                                :url="url_documentacion"
                                :maxFiles="5"
                                :maxFilesize="maxFilesize"
                                @success="imagenSubida"
                                acceptedFiles="image/jpeg,image/png,image/gif,image/bmp,image/tiff,application/pdf,.pdf"
                            />
                            <h3 style="font-size: 19px;" class="py-3">Peso máximo: {{ maxFilesize }} MB</h3>
                            <p v-if="documentaciones.length > 0" class="text-success mt-2">
                                Documentación adjunta: {{ documentaciones.length }} archivo(s).
                            </p>
                            <div class="alert alert-danger mt-2" v-if="error_documentacion">
                                {{ $t('nuevo_abono.error_documentacion') }}
                            </div>
                        </div>
                        <b-col cols="12" class="my-3" v-if="teatro.id == 124"> <!-- CD Lugo -->
                            <h3>{{ $t('renovar_abono.texto_lugo') }}</h3>
                        </b-col>
                        <div class="col-12 col-lg-8">
                            <table class="table tabla-resumen table-bordered mb-4 mb-lg-5">
                                <tr class="lightgray-content">
                                    <th></th>
                                    <th>{{ $t('general.abono', {abono: teatro.texto_abono}) }}</th>
                                    <th v-if="abonado.gastos_envio">{{ $t('general.gastos_envio') }}</th>  
                                    <th class="price">{{ $t('general.precio') }}</th>
                                </tr>

                                <tr>
                                    <td class="h1 text-center regular">Abono</td>
                                    <td>
                                        <strong class="text-bold h5 d-block mb-1">Tipo abono</strong>
                                        <template>
                                            <strong class="text-bold h7 d-block mb-1">{{ abonado.titulo.NombreZona }}</strong>
                                            <strong class="text-bold h7 d-block mb-1"> {{ $t('general.fila') }}: {{ abonado.titulo.Fila }} - {{ $t('general.butaca') }}: {{ abonado.titulo.Asiento }}</strong>
                                        </template>                          
                                    </td>
                                    <td v-if="abonado.gastos_envio"></td>
                                    <td>
                                        <div class="h3 m-0">{{ abonado.total_price | formatear_precio }}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2"></td>
                                    <td v-if="abonado.gastos_envio"><span class="total-price h2 m-0">{{ abonado.gastos_envio | formatear_precio }}</span></td>
                                    <td>
                                        <span class="total-price h2 m-0">{{ precio_total | formatear_precio }}<small v-if="! abonado.gastos_internos">*</small></span>
                                    </td>
                                </tr>
                            </table>
                            
                            <div class="col-12 col-lg-8 mt-4">
                                <FormTerminos 
                                    :error="error"
                                    @continuar="aceptarCondiciones"
                                />
                            </div>
                            <p class="mb-2 mb-md-4">
                                <small v-if="! abonado.gastos_internos">
                                    * {{ $t('general.el_precio', { precio: $options.filters.formatear_precio(precio_total - abonado.gastos), gastos: $options.filters.formatear_precio(abonado.gastos), iva: 21, moneda: '€' }) }}
                                </small>
                            </p>
                            <button id="terminar-compra" class="button large-button effect-button" @click.prevent="terminar"><span>{{ $t('nuevo_abono.continuar') }}</span></button>
                            <template v-if="abonado.formulario_compra != null" >
                                <div id="formulario-compra" v-html="abonado.formulario_compra" v-show="false"></div>
                            </template>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
        <transition name="fade" mode="out-in">
            <section v-if="procesar_pago" :class="'padding-vertical-content mb-3 mb-lg-4 ' + (lista_abonados.permitir_envio_a_domicilio ? 'lightgray-content' : '')" key="pago" id="pago">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                            <PagoPaycometComponent
                                ref="pago"
                                tipo_venta="renovar-abono-lfp"
                                :jet_id="abonado.jet_id"
                                :session_id="abonado.session_id"
                                :importe-carrito="icImporteBase"
                                :gastos-gestion-unitarios="icGastosGestionUnitarios"
                                :store="$store"
                                :get-vuex-alias="config.getVuexAlias"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </transition>
    </div>
</template>

<script>
    import BuscarAbonadoLfp from '@/components/frontend/abonos/renovar/components/BuscarAbonadoLfp';
    import PersonaInfoForm from '@/components/frontend/abonos/renovar/components/PersonaInfoForm';
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import EnviosComponent from '../nuevo/EnviosComponent.vue';
    import PagoPaycometComponent from "@/components/frontend/compra/components/PagoPaycometComponent";
    import Dropzone from '@/components/common/Dropzone';

    export default {
        data() {
            return {
                paso1: true,
                paso2: false,
                paso3: false,
                envio: false,
                loading: false,
                abonado: null,
                terminos: false,
                error: false,
                yaRenovado: false,
                procesar_pago: false,
                datos: {},
                solicitar_documentacion: false,
                texto_documentacion: '',
                documentaciones: [],
                url_documentacion: null,
                maxFilesize: 20,
                error_documentacion: false
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro
            },
            precio_total() {
                let precio = this.abonado.total_price;

                if(this.abonado.gastos_envio) {
                    precio += this.abonado.gastos_envio;
                }

                return precio;
            },
            icImporteBase() {
                return Number(
                    this.abonado?.instant_credit?.base_amount
                        ?? this.precio_total
                        ?? 0
                );
            },
            icGastosGestionUnitarios() {
                return Number(this.abonado?.instant_credit?.fee_per_installment ?? 0);
            }
        },
        methods: {
            abonadoEncontrado(abonado) {
                this.abonado = abonado;

                // Si el abonado ya está activo en la temporada actual, no permitir continuar
                if (abonado?.activo_temporada_actual) {
                    this.yaRenovado = true;
                    return;
                }

                if(this.lista_abonados.permitir_envio_a_domicilio) {
                    this.paso1 = false;
                    this.envio = true;
                } else {
                    this.paso1 = false;
                    this.paso2 = true;
                }
            },
            setDocumentacion({ solicitar_documentacion, texto_documentacion }) {
                this.solicitar_documentacion = !!solicitar_documentacion;
                this.texto_documentacion = texto_documentacion || '';

                if (this.solicitar_documentacion) {
                    this.setDropZone();
                }
            },
            setDropZone() {
                this.url_documentacion = this.config.API_BASE + '/f/upload/documento?tid=' + this.configuracion.hash_teatro;
            },
            imagenSubida(file, response) {
                // El backend devuelve el id directamente (no envuelto en {id}).
                // Acepta también respuestas con forma { id } o { data: { id } } por compatibilidad.
                const id = response?.id
                    ?? response?.data?.id
                    ?? (typeof response === 'number' || typeof response === 'string' ? response : null);
                if (id !== null && id !== undefined && id !== '') {
                    this.documentaciones.push(id);
                    this.error_documentacion = false;
                }
            },
            terminar() {
                this.loading = true;
                this.error_documentacion = false;
                if (this.terminos) {
                    if (this.solicitar_documentacion && (!this.documentaciones || this.documentaciones.length === 0)) {
                        this.error_documentacion = true;
                        this.loading = false;
                        return;
                    }

                    this.guardarTerminosCondiciones();
                    if (this.abonado.formulario_compra) {
                        setTimeout(() => {
                            const form = document.querySelector('#formulario-compra form');
                            if (form) form.submit();
                        }, 500);
                    }

                    if (this.abonado.jet_id) {
                        this.procesar_pago = true;
                        this.$nextTick(function() {
                            this.$scrollTo('#pago');
                        });
                    }
                } else {
                    this.loading = false;
                    this.error = true;
                }                
            },
            guardarTerminosCondiciones(){
                const data = {
                    filters: {
                        session_id: this.abonado.session_id,
                        privacidad: this.datos.privacidad,
                        condiciones: this.datos.condiciones,
                        comunicaciones: this.datos.comunicaciones,
                    },
                    session_id: this.abonado.session_id,
                    privacidad: this.datos.privacidad,
                    condiciones: this.datos.condiciones,
                    comunicaciones: this.datos.comunicaciones
                }

                const guardarTerminos = () => {
                    this.$store.dispatch(this.config.getVuexAlias('front.abonados.compra.terminos-y-condiciones'), data).then(res => { });
                };

                if (this.solicitar_documentacion && this.documentaciones.length > 0) {
                    const params = {
                        filters: {},
                        tid: this.configuracion.hash_teatro,
                        session_id: this.abonado.session_id,
                        documentaciones: this.documentaciones
                    };

                    this.$store.dispatch(this.config.getVuexAlias('lfp.abono.guardar.documentacion'), params).then(res => {
                        guardarTerminos();
                    }).catch(error => {
                        this.loading = false;
                        const message = error?.response?.data?.message || 'Error al guardar la documentación.';
                        this.$toast.error(message);
                    });
                } else {
                    guardarTerminos();
                }
            },
            aceptarCondiciones(continuar, privacidad, condiciones, comunicaciones) {
                this.datos.privacidad = privacidad;
                this.datos.condiciones = condiciones;
                this.datos.comunicaciones = comunicaciones;
                this.terminos = continuar == true;
            },
            envioSolicitado(datos_envio) {
                const params = {
                    filters: {},
                    tid: this.configuracion.hash_teatro,
                    session_id: this.abonado.session_id,
                    datos_envio: datos_envio
                }

                this.$store.dispatch(this.config.getVuexAlias('lfp.abono.solicitar.envio'), params).then(res => {
                    this.abonado.formulario_compra = res.data.formulario_compra;
                    this.abonado.jet_id = res.data.jet_id;
                    this.abonado.gastos_envio = res.data.gastos_envio;
                    this.$set(this.abonado, 'instant_credit', res.data.instant_credit);
                    this.envio = false;
                    this.paso2 = true;
                });
            },
            continuarSinEnvio() {
                this.envio = false;
                this.paso2 = true;
            }
        },
        components: {
            BuscarAbonadoLfp, PersonaInfoForm, FormTerminos, EnviosComponent, PagoPaycometComponent, Dropzone
        }
    }
</script>
